import { Card, Row, Col, Button, notification, Icon, Input, Tooltip, Divider } from "antd";
import React from "react";
import { connect } from "react-redux";
import QRCode from "react-qr-code";

class StudentPanelQRCode extends React.Component {
    state = {}

    qrCodePrint = () => {
        const prtContent = document.getElementById("qr-code-section");
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

        // Adding basic styles to the print window so it looks centered and professional
        WinPrint.document.write(`
            <html>
                <head>
                    <title>Print QR Code</title>
                    <style>
                        body { font-family: sans-serif; display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; margin: 0; text-align: center; }
                        h2 { color: #262626; margin-bottom: 20px; }
                        p { color: #8c8c8c; margin-top: 20px; }
                    </style>
                </head>
                <body>
                    <h2>Student Registration Portal</h2>
                    ${prtContent.innerHTML}
                    <p>Scan to Register</p>
                </body>
            </html>
        `);
        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
    }

    handleCopy = () => {
        const copyText = document.getElementById("webLinkCopy");
        copyText.select();
        navigator.clipboard.writeText(copyText.value);
        notification.success({
            message: "Link Copied!",
            description: "Registration link has been copied to clipboard.",
            placement: "bottomRight"
        });
    }

    render() {
        // Safe data access for React 16.7
        const currentUser = this.props.currentUser || {};
        const registrationLink = `https://student.tenagents.com/register?businessId=${currentUser.businessId}&brnch=${currentUser.userBranch}`;

        return (
            <Card
                className="modern-list-card"
                style={{ marginTop: 20 }}
                bodyStyle={{ padding: "24px" }} // Added internal padding for better Row/Col spacing
                bordered={true}
                title={
                    <span style={{ color: '#fff' }}>
                        <Icon type="qrcode" style={{ marginRight: 8, color: '#fff' }} />
                        Student Registration Access
                    </span>
                }
            >
                <Row gutter={32} align="middle" type="flex">
                    {/* LEFT SIDE: QR CODE SECTION */}
                    <Col xs={24} md={8} style={{ textAlign: 'center', borderRight: '1px solid #f0f0f0' }}>
                        <div style={{ padding: '20px', background: '#fafafa', borderRadius: '12px', display: 'inline-block' }}>
                            <div id='qr-code-section' style={{ background: '#fff', padding: '15px', borderRadius: '8px', border: '1px solid #e8e8e8' }}>
                                <QRCode
                                    size={256}
                                    style={{ height: "auto", maxWidth: '100%', width: "160px" }}
                                    value={`${currentUser.businessId}-${currentUser.userBranch}`}
                                    viewBox={`0 0 256 256`}
                                />
                            </div>
                        </div>
                        <div style={{ marginTop: '16px' }}>
                            <Button
                                type="primary"
                                icon="printer"
                                ghost
                                onClick={this.qrCodePrint}
                            >
                                Print QR Code
                            </Button>
                        </div>
                    </Col>

                    {/* RIGHT SIDE: WEB LINK SECTION */}
                    <Col xs={24} md={16}>
                        <div style={{ padding: '10px 0' }}>
                            <h4 style={{ color: '#262626', marginBottom: '16px' }}>Registration Web Link</h4>
                            <p style={{ color: '#8c8c8c', fontSize: '13px' }}>
                                Share this link with students or add it to your website for direct registrations.
                            </p>

                            <div style={{ display: 'flex', marginTop: '20px' }}>
                                <Input
                                    id='webLinkCopy'
                                    value={registrationLink}
                                    readOnly
                                    size="large"
                                    addonBefore={<Icon type="link" />}
                                    addonAfter={
                                        <Tooltip title="Copy Link">
                                            <Icon
                                                type="copy"
                                                style={{ cursor: 'pointer', color: '#1890ff' }}
                                                onClick={this.handleCopy}
                                            />
                                        </Tooltip>
                                    }
                                />
                            </div>

                            <Divider orientation="left" style={{ fontSize: '12px', color: '#bfbfbf' }}>Instructions</Divider>

                            <ul style={{ color: '#595959', fontSize: '12px', paddingLeft: '20px', lineHeight: '2' }}>
                                <li>Scan the QR code using a mobile camera to open the registration form.</li>
                                <li>Print and display the QR code at your office front desk.</li>
                                <li>Copy and send the URL directly to students via WhatsApp or Email.</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Card>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    currentUser: global.currentUser,
    loading: global.buttonLoading
});

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(StudentPanelQRCode);